import React, { useEffect, useState } from "react"
import { FlexContainer, H2 } from "@carrotfertility/carotene"
import { CenteredLoadingIndicator } from "components/views/molecules/Molecules"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import useInitialSetup from "components/csd-enrollment/hooks/useInitialSetup"
import { Steps } from "components/csd-enrollment/workflow/steps"
import { useUserDeductible } from "components/context/user/DeductibleContext"
import { waitForMinimumDelay } from "../../../../utils/WaitForMinimumDelay"
import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"

export default function PeekBenefitEnrollmentStep(): JSX.Element {
  const viewName = Steps.PEEK_BENEFIT_ENROLLMENT
  const [loading, setLoading] = useState(true)
  const { shouldSkipPeekEnrollment, deductibleFlowType } = useBenefitEnrollment()

  const { setNextStep } = useStateMachine(viewName, shouldSkipPeekEnrollment ? deductibleFlowType : null)
  const { retrieveDeductiblePreview, hraEligibility } = useUserDeductible()

  useInitialSetup(async () => {
    if (!shouldSkipPeekEnrollment) {
      await waitForMinimumDelay(retrieveDeductiblePreview(), 1000)
    }
    setLoading(false)
  })
  useEffect(() => {
    if (!loading) {
      const isHraIneligible =
        deductibleFlowType === "CSD" &&
        (hraEligibility.memberHraEligibility === false || hraEligibility.partnerHraEligibility === false)
      setNextStep(viewName, isHraIneligible ? "HRA_INELIGIBLE" : deductibleFlowType)
    }
  }, [retrieveDeductiblePreview, deductibleFlowType, hraEligibility, viewName, loading])
  return (
    <FlexContainer alignItems="center" direction="column" paddingTopBottom="large">
      <CenteredLoadingIndicator />
      <H2 variant="primary" stack="medium">
        {"We're working on your request."}
      </H2>
    </FlexContainer>
  )
}
